






































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import {$} from '@/facade'

@Component({})
export default class MyWalletConnectAddress extends Vue {
  @Prop({type: MyWalletCacheAssist, required: true})
  cacheAssist!: MyWalletCacheAssist

  computedWatchWalletAddress: string = ''

  handleConnectWallet() {
    $.modal.open('connectWalletModal')
  }

  async onClickConnectWatchWallet() {
    await this.cacheAssist.populateWatchWallet(this.computedWatchWalletAddress)
  }
}
